{
  "got-it": "Begrepen",
  "mercury.email.footer.sent-by": "Dit bericht is naar jou gestuurd door Atlassian Focus",
  "mercury.email.footer.unsubscribe": "Afmelden",
  "mercury.focus-areas.arrow-icon.alt": "pictogram-pijl",
  "mercury.focus-areas.arrow-right-icon.alt": "pictogram-rechter-pijl",
  "mercury.focus-areas.calendar-icon.alt": "pictogram-kalender",
  "mercury.focus-areas.date-changed": "Datum gewijzigd",
  "mercury.focus-areas.focus-area.alt": "pictogram-aandachtsgebied",
  "mercury.focus-areas.focus-footer.alt": "Atlassian-voettekst",
  "mercury.focus-areas.focus-icon.alt": "Pictogram aandachtsgebied",
  "mercury.focus-areas.for": "for",
  "mercury.focus-areas.heading": "You're following {total} active focus areas, here's the breakdown.",
  "mercury.focus-areas.no-target-date.alt": "Geen streefdatum vastgesteld",
  "mercury.focus-areas.status-changed": "Status gewijzigd",
  "mercury.focus-areas.view-area": "Aandachtsgebied bekijken",
  "mercury.focus.catch.up.link": "Ga naar Atlassian Focus",
  "mercury.focus.catch.up.text": "Wil je eerdere updates lezen? {link}",
  "mercury.mercury-monthly-digest.message-template.email.subject.no-translate": "{name}, hier zijn je maandelijkse updates over het aandachtsgebied",
  "mercury.message-templates.edit-focus-area-heirarchy-spotlight-body": "Wanneer je wijzigingen moet aanbrengen aan je hiërarchie, kun je dit doen vanuit de instellingen.",
  "mercury.message-templates.edit-focus-area-heirarchy-spotlight-heading": "De hiërarchie van je aandachtsgebied bewerken"
}